import { setSelectedParcours } from "../reducers/parcours"
import { store } from "../store/store"
import axios from "axios"

const { PARCOURS_API_ROUTE } = require("../../routes/api/api_routes")


const parcours = {
    createParcours(data){
        return new Promise((resolve,reject)=>{
            axios.post(PARCOURS_API_ROUTE,data,{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                }
              })
            .then(response => {
                if(response.status === 201){
                    let parcours = response.data
                    let dispatch = store.dispatch
                    dispatch(setSelectedParcours(parcours))
                    resolve(parcours)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
}
export default parcours